import * as React from 'react';
import { Input } from 'antd';
import intl from 'react-intl-universal';

import './index.less';

export interface DescriptionItemProps {
    value?: any;
    onChange?: (value: any) => void;
    id?: string;
    desc?: string;
    onFocus?: (value: any) => void;
    errorMsg?: string;
}

const DescriptionItem: React.FC<DescriptionItemProps> = ({
    value,
    onChange,
    id,
    desc,
    ...props
}) => {
    return (
        <div id={id} className="questionnaire__form__textArea-wrapper">
            {desc && <div className="desc">{desc}</div>}
            <Input.TextArea
                value={value}
                onChange={onChange}
                style={{ height: 98, resize: 'none' }}
                placeholder={intl.get('pleaseEnter')}
                {...props}
            />
        </div>
    );
};

export default DescriptionItem;
